const REVOKE_DELAY_MS = 60_000;

/**
 * Opens a Blob (e.g. a PDF fetched from the API) in a new browser tab using
 * the browser's native viewer, which has its own reliable print button.
 *
 * The tab is opened with `noopener`, falls back to a download when the popup
 * is blocked, and the object URL is always revoked afterwards.
 */
export function openBlobInNewTab(blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const opened = window.open(url, '_blank', 'noopener');

  if (!opened) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
}
